import type { ReactElement } from 'react';

import { UserActivationFlow } from 'module/user/activation/components/UserActivationFlow';

import { useDeviceHandoffAccountFlow } from '../hooks/useDeviceHandoffAccountFlow';

export const ActivationRoute = (): ReactElement => <UserActivationFlow {...useDeviceHandoffAccountFlow().activation} />;
